module.exports = __webpack_public_path__ + "static/media/education.c8a0892d.png";